import React from 'react';
import { HStack, Button, Badge, Tooltip, Box, Text, IconButton, Icon, Flex } from '@chakra-ui/react';
import { FaClock, FaExclamationTriangle, FaHourglassHalf, FaCheckCircle, FaThList, FaBackspace, FaFlag } from 'react-icons/fa';

const CHIPS = [
    { value: '',          label: 'Todas',     icon: FaThList,              colorScheme: 'gray',   tip: 'Remover filtro de urgência' },
    { value: 'atrasada',  label: 'Atrasadas', icon: FaExclamationTriangle, colorScheme: 'red',    tip: 'Prazo venceu e ainda não foi revisada' },
    { value: 'urgente',   label: 'Urgentes',  icon: FaClock,               colorScheme: 'red',    tip: 'Última chance para revisar hoje' },
    { value: 'proxima',   label: 'Próximas',  icon: FaHourglassHalf,       colorScheme: 'orange', tip: 'Prazo chega nos próximos 3 dias úteis' },
    { value: 'normal',    label: 'No prazo',  icon: FaCheckCircle,         colorScheme: 'green',  tip: 'Prazo confortável' },
    { value: 'sem_prazo', label: 'Sem prazo', icon: FaThList,              colorScheme: 'gray',   tip: 'Já encerradas ou sem prazo informado' },
];

const DevolucoesUrgencyFilters = ({ value, onChange, onClear, totals = {}, comDivergencia = false, onChangeComDivergencia }) => {
    const getCount = (v) => {
        switch (v) {
            case 'atrasada': return totals.total_atrasadas;
            case 'urgente':  return totals.total_urgentes;
            case 'proxima':  return totals.total_proximas;
            default: return undefined;
        }
    };

    const hasActiveFilter = !!value;
    const divergenciaCount = totals.total_com_divergencia;

    return (
        <Box w="100%" mt={3} mb={1}>
            <HStack justify="space-between" align="center" px={1} mb={1.5}>
                <HStack spacing={1.5}>
                    <Icon as={FaClock} color="#F68633" boxSize={3} />
                    <Text fontSize="10px" fontWeight="bold" color="#F68633" letterSpacing="wider">
                        FILTRO RÁPIDO POR PRAZO DE REVISÃO
                    </Text>
                </HStack>
                {hasActiveFilter && onClear && (
                    <Tooltip label="Limpar filtro de urgência" openDelay={300}>
                        <IconButton
                            size="xs"
                            variant="ghost"
                            colorScheme="orange"
                            aria-label="Limpar filtro de urgência"
                            icon={<FaBackspace />}
                            onClick={onClear}
                        />
                    </Tooltip>
                )}
            </HStack>
            <Box overflowX="auto" pb={1} sx={{ WebkitOverflowScrolling: 'touch' }}>
                <HStack spacing={2} align="center" minW="max-content">
                    {CHIPS.map((chip) => {
                        const isActive = value === chip.value;
                        const count = getCount(chip.value);
                        return (
                            <Tooltip key={chip.value || 'todas'} label={chip.tip} openDelay={400}>
                                <Button
                                    size="sm"
                                    variant={isActive ? 'solid' : 'outline'}
                                    colorScheme={chip.colorScheme}
                                    onClick={() => onChange(isActive ? '' : chip.value)}
                                    leftIcon={<Icon as={chip.icon} />}
                                    flexShrink={0}
                                    fontWeight={isActive ? 'bold' : 'medium'}
                                    rightIcon={count !== undefined && count > 0 ? (
                                        <Badge
                                            colorScheme={isActive ? 'whiteAlpha' : chip.colorScheme}
                                            variant={isActive ? 'solid' : 'subtle'}
                                            fontSize="10px"
                                        >
                                            {count}
                                        </Badge>
                                    ) : null}
                                >
                                    {chip.label}
                                </Button>
                            </Tooltip>
                        );
                    })}
                    {onChangeComDivergencia && (
                        <Tooltip label="Mostrar apenas devoluções com divergência sinalizada" openDelay={400}>
                            <Button
                                size="sm"
                                variant={comDivergencia ? 'solid' : 'outline'}
                                colorScheme="red"
                                onClick={() => onChangeComDivergencia(!comDivergencia)}
                                leftIcon={<Icon as={FaFlag} />}
                                flexShrink={0}
                                fontWeight={comDivergencia ? 'bold' : 'medium'}
                                rightIcon={divergenciaCount !== undefined && divergenciaCount > 0 ? (
                                    <Badge
                                        colorScheme={comDivergencia ? 'whiteAlpha' : 'red'}
                                        variant={comDivergencia ? 'solid' : 'subtle'}
                                        fontSize="10px"
                                    >
                                        {divergenciaCount}
                                    </Badge>
                                ) : null}
                            >
                                Com Divergência
                            </Button>
                        </Tooltip>
                    )}
                </HStack>
            </Box>
        </Box>
    );
};

export default DevolucoesUrgencyFilters;
